module.exports = __webpack_public_path__ + "static/mobile-banner-a9572a130d274104bb255797f7c8f25f.svg";